// extracted by mini-css-extract-plugin
module.exports = {"emptyInstructions":"EmptyInstructions--styles-module_emptyInstructions-1Ld9S"};